import React, { useState } from "react";
import s from "../CourseComment.module.css";
import { useAuth } from "../context/AuthContext";
import { useParams } from "react-router-dom";
import { useAppTranslation } from "./TranslationContext";

export const CourseComment = () => {
  const { id: kursId } = useParams();
  const { t } = useAppTranslation();
  const { user } = useAuth();

  const [stars, setStars]     = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stars) {
      setSuccess(false);
      setMessage(t('pickStars'));
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const res = await fetch("https://api.aiassessment.uz/api/comment-kurs/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify({
          stars,
          comment,
          user: user.id,
          kurs: kursId,
        }),
      });

      if (!res.ok) throw new Error(t('commentError'));

      setSuccess(true);
      setMessage(t('commentSend'));
      setStars(0);
      setComment("");
    } catch (error) {
      setSuccess(false);
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={s.page}>
      <div className={s.card}>
        <span className={s.label}>{t('rateTitle')}</span>
        <h1 className={s.title}>{t('rateTitle')}</h1>

        <form onSubmit={handleSubmit}>

          {/* Stars */}
          <div className={s.starsRow}>
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                className={`${s.star} ${star <= stars ? s.starFilled : ''}`}
                onClick={() => setStars(star)}
              >
                ★
              </span>
            ))}
          </div>

          {/* Comment */}
          <textarea
            className={s.textarea}
            placeholder={t('rateComment')}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />

          {/* Submit */}
          <button type="submit" className={s.submitBtn} disabled={loading}>
            <span className={s.submitBtnText}>
              {loading ? t('sending') : t('send')}
            </span>
          </button>

        </form>

        {message && (
          <p className={`${s.message} ${success ? s.messageSuccess : s.messageError}`}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
};
